import { defineMessages } from "react-intl";

export const scope = "components.DetailsField";

export const messages = defineMessages({
  notificationTitle: {
    id: `${scope}.notificationTitle`,
    defaultMessage: "Copiado con exito",
  },
  defaultNotificationMessage: {
    id: `${scope}.defaultNotificationMessage`,
    defaultMessage: "Tienes en el porta papeles el contenido del campo",
  },
});
